import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'
import store from '../store/index'

export function _getAll(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getAllExpenseCenterCombo(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters/all`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _create(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
export function _update(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _getById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _delete(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/expenseCenters/${id}`;
    return axios.delete(url,config).then(_handleSuccess,_handleError)
}